import type { Ref } from 'vue'

import { useScrollLock } from '@vueuse/core'
import { watch } from 'vue'

/**
 * Freezes the page behind an overlay while it is open.
 *
 * Without it a thumb aiming for a cart line drags the menu underneath instead.
 * Every overlay in this domain needs it, and each one had written its own
 * `document.body.style.overflow` pair plus an unmount guard — one of which would
 * eventually forget the guard and leave the page unscrollable.
 *
 * Wraps @vueuse/core rather than reimplementing it: the dependency is already
 * here, and it restores the previous value on scope dispose, so a component
 * unmounted while its overlay is open cannot strand the lock.
 */
export const useBodyScrollLock = (isOpen: Ref<boolean>): void => {
  const isLocked = useScrollLock(document.body)

  watch(isOpen, open => (isLocked.value = open), { immediate: true })
}
